import React from 'react';

import { Flex } from '@chakra-ui/react';
import styled from '@emotion/styled';
import { Link } from 'react-router-dom';

import { Button } from 'uiToolkitV1/Button';
import { PaperWithShadow } from 'uiToolkitV1/Paper';
import { TextBodyMedium } from 'uiToolkitV1/Typography';

const StyledLink = styled(Link)`
  text-decoration: none;
`;

const MySummaryCardTemplate = ({
  Icon,
  heading = '',
  viewAllText = '',
  onClickViewAll = () => {},
  showViewAllButton = true,
  HeaderRightComp,
  viewAllHref = null,
  children,
  ...props
}) => {
  const headerRightCompExists = !!HeaderRightComp;
  return (
    <PaperWithShadow borderRadius="8px" px={3} py={2} {...props}>
      <Flex flexDir="column">
        <Flex alignItems="center" gap={2} px={2} pt={1} pb={3} borderBottom="1px solid" borderColor="border.CFD7DF">
          {Icon && <Icon fill="transparent" boxSize="24px" color="icon.g2" />}
          <TextBodyMedium bold color="text.g1">
            {heading}
          </TextBodyMedium>
          {headerRightCompExists && <HeaderRightComp />}
        </Flex>
        {children}
        {showViewAllButton && (
          <Flex
            sx={{
              button: {
                paddingBottom: '0px',
              },
            }}
          >
            {viewAllHref ? (
              <StyledLink to={viewAllHref}>
                <Button onClick={onClickViewAll} variant="tertiary">
                  {viewAllText}
                </Button>
              </StyledLink>
            ) : (
              <Button onClick={onClickViewAll} variant="tertiary">
                {viewAllText}
              </Button>
            )}
          </Flex>
        )}
      </Flex>
    </PaperWithShadow>
  );
};

export { MySummaryCardTemplate };
